var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCClogopurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.411 359.056C492.256 354.865 490.168 350.03 485.909 348.347L441.717 330.884C437.499 329.217 432.741 331.275 430.863 335.405C400.655 401.821 333.72 448 256 448C149.961 448 64 362.039 64 256C64 149.961 149.961 64.0001 256 64.0001C333.874 64.0001 400.92 110.362 431.041 176.99C432.942 181.194 437.818 183.253 442.073 181.468L485.851 163.11C490.02 161.362 492.02 156.577 490.19 152.443C450.424 62.6471 360.528 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512C360.722 512 450.758 449.12 490.411 359.056Z",
    fill: "url(#paint0_linear_426_59923)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M391.05 319.822C393.015 315.672 390.921 310.811 386.651 309.124L342.417 291.645C338.225 289.988 333.515 292.024 331.399 296.004C317.062 322.977 288.676 341.344 255.999 341.344C208.871 341.344 170.666 303.139 170.666 256.011C170.666 208.882 208.871 170.677 255.999 170.677C289.522 170.677 318.53 190.008 332.485 218.131C334.566 222.325 339.491 224.487 343.809 222.676L387.507 204.351C391.65 202.614 393.665 197.87 391.791 193.787C368.195 142.379 316.266 106.677 255.999 106.677C173.524 106.677 106.665 173.536 106.665 256.011C106.665 338.485 173.524 405.344 255.999 405.344C315.644 405.344 367.122 370.376 391.05 319.822Z",
    fill: "url(#paint1_linear_426_59923)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_426_59923",
    x1: 0,
    y1: 510.873,
    x2: 481.563,
    y2: 510.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8255FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B77FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_426_59923",
    x1: 0,
    y1: 510.873,
    x2: 481.563,
    y2: 510.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8255FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B77FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCClogopurple);
export default __webpack_public_path__ + "static/media/CC logo purple.9af64378cf0a9df2d6a68af8da3db2a6.svg";
export { ForwardRef as ReactComponent };